import React, { Component } from 'react';
import { } from 'reactstrap';
import { } from './../../Prismic/PrismicContent';

class BlogPost extends Component {

    render() {
        let post = this.props.post;
        return (
            <div>
            </div>
        );
    }

} export default BlogPost;


// WEBPACK FOOTER //
// ./src/Components/PageComponents/BlogPost.js